var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.39139 5.25H5.25C5.66421 5.25 6 5.58579 6 6C6 6.41422 5.66421 6.75 5.25 6.75H2.25C1.42157 6.75 0.75 6.07843 0.75 5.25V2.25C0.75 1.83579 1.08579 1.5 1.5 1.5C1.91421 1.5 2.25 1.83579 2.25 2.25V4.25657C3.10658 3.03763 4.28144 2.06782 5.65487 1.45861C7.34057 0.710887 9.22819 0.549495 11.0164 1.0002C12.8045 1.45091 14.3901 2.48774 15.52 3.94514C16.4962 5.20425 17.0836 6.71457 17.2195 8.29139C17.2551 8.70407 16.9108 9.03889 16.4966 9.03685C16.0824 9.03481 15.7492 8.69634 15.7053 8.28447C15.573 7.04502 15.099 5.86111 14.3293 4.86829C13.4058 3.67704 12.1097 2.82957 10.6481 2.46117C9.18651 2.09278 7.64362 2.22469 6.26577 2.83587C5.11742 3.34524 4.1389 4.16304 3.43496 5.19172C3.42118 5.21186 3.40664 5.2313 3.39139 5.25Z",
    fill: "#4B4B4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 13.7434C14.8934 14.9624 13.7186 15.9322 12.3451 16.5414C10.6594 17.2891 8.77181 17.4505 6.98364 16.9998C5.19547 16.5491 3.60987 15.5123 2.47997 14.0549C1.5038 12.7958 0.916399 11.2854 0.780479 9.70862C0.744907 9.29594 1.08921 8.96112 1.50342 8.96316C1.91763 8.96519 2.25078 9.30367 2.29472 9.71554C2.42698 10.955 2.90097 12.1389 3.6707 13.1317C4.59424 14.323 5.89028 15.1704 7.35188 15.5388C8.81348 15.9072 10.3564 15.7753 11.7342 15.1641C12.8826 14.6548 13.8611 13.837 14.565 12.8083C14.5788 12.7881 14.5934 12.7687 14.6086 12.75H12.75C12.3358 12.75 12 12.4142 12 12C12 11.5858 12.3358 11.25 12.75 11.25H15.75C16.5784 11.25 17.25 11.9216 17.25 12.75V15.75C17.25 16.1642 16.9142 16.5 16.5 16.5C16.0858 16.5 15.75 16.1642 15.75 15.75V13.7434Z",
    fill: "#4B4B4A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.aa2f31615e25e6136047cf6d41fceb90.svg";
export { ForwardRef as ReactComponent };